/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import LabelledField from "components/labelled-field";
import { ComponentCardsSimpleItemContext } from "./component-cards-simple-context";
import { CardsSimpleImage } from "./cards-simple-image";

const CardsSimpleItemEditor = () => {

    const { t } = useTranslation();
    const {
        position,
        item,
        updateItemByPosition
    } = useContext(ComponentCardsSimpleItemContext) || {};

    const _image = item?.image;
    const _heading = item?.heading;
    const [image, setImage] = useState(_image);
    const [heading, setHeading] = useState(_heading);

    const updateImage = (guid) => {
        setImage(guid);
    };

    const onChangeHeading = (event) => {
        const newHeading = event.target.value;
        setHeading(newHeading);
    };

    useEffect(
        () => {
            const nextItem = structuredClone({
                ...item,
                image,
                heading,
            });
            updateItemByPosition(nextItem, position);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [heading, image]
    );

    return (
        <div className='simplicity-cards-simple-item'>
            <LabelledField label={`${t("commons.heading")}: `}>
                <TextField
                    onChange={onChangeHeading}
                    id='heading'
                    defaultValue={heading}
                    fullWidth={true}
                />
            </LabelledField>
            <CardsSimpleImage
                image={image}
                updateImage={updateImage}
            />
        </div>
    );
};
CardsSimpleItemEditor.displayName = "CardsSimpleItemEditor";
export { CardsSimpleItemEditor };
